import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/theme/light2.png'


const _hoisted_1 = { class: "sprite-animation" }

import { onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'animatedGifttwo',
  setup(__props) {

const startAnimation = ref(false);

onMounted(() => {
    setTimeout(() => {
        startAnimation.value = true;
    }, 100);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      class: "bgLight",
      src: _imports_0,
      alt: ""
    }, null, -1)
  ])))
}
}

})